<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="convenio.idSituacaoConvenio != 9"
                >Adicionar
            </b-button>
        </b-button-group>
        <b-modal
            id="modalPrestacaoFinal"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Dados da Despesa -
                <b-badge variant="warning">NOVO</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Tipo da Prestação</label>
                        <b-input-group>
                            <b-form-select
                                id="codTipoPrestacaoContas"
                                type="text"
                                :options="tiposPrestacoes"
                                value-field="key"
                                text-field="label"
                                v-model="prestacoesFinal.codTipoPrestacaoContas"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback
                                >Natureza é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="idAcao">Ações</label>
                        <b-input-group>
                            <b-form-select
                                id="idAcao"
                                type="text"
                                :options="acoes"
                                value-field="idAcaoConvenio"
                                text-field="descricao"
                                v-model="prestacoesFinal.idAcaoConvenio"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback
                                >Natureza é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label for="NaturezaDespesa">Natureza da Despesa</label>
                        <b-input-group>
                            <b-form-select
                                id="NaturezaDespesa"
                                type="text"
                                :options="naturezas"
                                value-field="idNaturezaDespesa"
                                text-field="descricaoCompleta"
                                v-model="prestacoesFinal.idNaturezaDespesa"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback
                                >Natureza é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="vcDocumento">Nº Documento</label>
                        <b-input-group>
                            <b-form-input
                                id="vcDocumento"
                                type="text"
                                v-model="prestacoesFinal.vcDocumento"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >Documento é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="9">
                    <b-form-group>
                        <label for="vcFavorecido">Favorecido</label>
                        <b-input-group>
                            <b-form-input
                                id="vcFavorecido"
                                type="text"
                                v-model="prestacoesFinal.vcFavorecido"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >Favorecido é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtEmissao">Data Emissão</label>
                        <b-input-group>
                            <date-picker
                                id="dtEmissao"
                                v-model="prestacoesFinal.dtEmissao"
                                @input.native="
                                    $v.convenio.dtInicioVigencia.$touch()
                                "
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                            <b-form-invalid-feedback
                                >Data Emissão é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="dtPagamento">Data Pagamento</label>
                        <b-input-group>
                            <date-picker
                                id="dtPagamento"
                                v-model="prestacoesFinal.dtPagamento"
                                @input.native="
                                    $v.convenio.dtInicioVigencia.$touch()
                                "
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                            ></date-picker>
                            <b-form-invalid-feedback
                                >Data Pagamento é
                                obrigatória</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuValor">Valor</label>
                        <b-input-group>
                            <money
                                id="nuValor"
                                v-model="prestacoesFinal.nuValor"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Valor Econômico</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuConfins">Cofins</label>
                        <b-input-group>
                            <money
                                id="nuConfins"
                                v-model="prestacoesFinal.nuCofins"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Cofins é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuCsll">CSLL</label>
                        <b-input-group>
                            <money
                                id="nuCsll"
                                v-model="prestacoesFinal.nuCsll"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Csll é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuInss">INSS</label>
                        <b-input-group>
                            <money
                                id="nuInss"
                                v-model="prestacoesFinal.nuInss"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Inss é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuIr">IR</label>
                        <b-input-group>
                            <money
                                id="nuIr"
                                v-model="prestacoesFinal.nuIr"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Ir é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuIss">ISS</label>
                        <b-input-group>
                            <money
                                id="nuIss"
                                v-model="prestacoesFinal.nuIss"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Inss é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label for="nuPis">PIS</label>
                        <b-input-group>
                            <money
                                id="nuPis"
                                v-model="prestacoesFinal.nuPis"
                                v-bind="money"
                                class="form-control text-right"
                                @input.native="$v.valor.$touch()"
                            ></money>
                            <b-form-invalid-feedback
                                >Pis é obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="salvar()" class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConvenioServicos'

export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
        idPrestacaoMensal: {
            type: Number,
            default: 0
        }
    },

    /*validations: {
            valor: {
                required,
                minValue: minValue(0.01)
            }
        },*/

    data() {
        return {
            mostrarModal: false,
            erros: [],
            naturezas: [],
            acoes: [],
            tiposPrestacoes: [
                {
                    key: '1',
                    label: 'RECURSOS SEBRAE'
                },
                {
                    key: '2',
                    label: 'CONTRAPARTIDA FINANCEIRA'
                },
                {
                    key: '3',
                    label: 'CONTRAPARTIDA ECONÔMICA'
                }
            ],
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            prestacoesFinal: {
                codSituacao: 1,
                codTipoPrestacaoContas: 0,
                dtEmissao: null,
                dtPagamento: null,
                idAcaoConvenio: 0,
                idNaturezaDespesa: 0,
                idPrestacaoContasFinal: 0,
                idPrestacaoContasMensal: 0,
                nuConfins: 0,
                nuCsll: 0,
                nuInss: 0,
                nuIr: 0,
                nuIss: 0,
                nuPis: 0,
                nuValor: 0,
                situacao: null,
                tipoPrestacaoContas: null,
                vcDoctoPag: null,
                vcDocumento: null,
                vcFavorecido: null,
                vcObservacao: null
            }
        }
    },

    methods: {
        limpar() {
            this.prestacoesFinal.codSituacao = 0
            this.prestacoesFinal.codTipoPrestacaoContas = 0
            this.prestacoesFinal.dtEmissao = null
            this.prestacoesFinal.dtPagamento = null
            this.prestacoesFinal.idAcaoConvenio = 0
            this.prestacoesFinal.idNaturezaDespesa = 0
            this.prestacoesFinal.idPrestacaoContasFinal = 0
            this.prestacoesFinal.idPrestacaoContasMensal =
                this.idPrestacaoMensal
            this.prestacoesFinal.nuConfins = 0
            this.prestacoesFinal.nuCsll = 0
            this.prestacoesFinal.nuInss = 0
            this.prestacoesFinal.nuIr = 0
            this.prestacoesFinal.nuIss = 0
            this.prestacoesFinal.nuPis = 0
            this.prestacoesFinal.nuValor = 0
            this.prestacoesFinal.situacao = null
            this.prestacoesFinal.tipoPrestacaoContas = null
            this.prestacoesFinal.vcDoctoPag = null
            this.prestacoesFinal.vcDocumento = null
            this.prestacoesFinal.vcFavorecido = null
            this.prestacoesFinal.vcObservacao = null
        },

        abrirModal() {
            this.mostrarModal = true
            this.limpar()
            this.listarAcoes()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        listarAcoes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarAcoes(this.convenio.idConvenio).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        listarNaturezas() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarNaturesasPorAcoes(
                this.convenio.idConvenio,
                this.prestacoesFinal.idAcaoConvenio
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.naturezas = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvar() {
            this.prestacoesFinal.dtEmissao = this.$moment(
                this.prestacoesFinal.dtEmissao,
                'DD/MM/YYYY'
            ).format('YYYY-MM-DD')
            this.prestacoesFinal.dtPagamento = this.prestacoesFinal.dtPagamento
                ? this.$moment(
                      this.prestacoesFinal.dtPagamento,
                      'DD/MM/YYYY'
                  ).format('YYYY-MM-DD')
                : ''

            this.$store.dispatch('addRequest')
            ConveniosServicos.InserirPrestacaoFinal(this.prestacoesFinal).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.prestacoesFinal = response.data
                            this.$emit('atualizarLista')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )

            this.fecharModal()
        }
    },

    watch: {
        'prestacoesFinal.idAcaoConvenio'() {
            this.listarNaturezas()
        }
    }
}
</script>
